/**
 * Sign/zero handling for change-styled numbers (PnL, deltas).
 * A value within the precision threshold renders as an UNSIGNED zero --
 * a bare `isUp ? '+' : '-'` ternary here once regressed to "-0" on every
 * flat PnL row (isUp === null fell into the '-' branch).
 *
 * The near-zero clamp exists ONLY for that "-0" rationale, which only applies
 * to change-styled (isChange) rows. A plain (non-change) amount -- e.g. a
 * referral accrued balance of 0.015 that floors to 0.01 at precision 2 -- is
 * not a delta and must never be clamped to 0 just because it is small; that
 * would silently hide a real, non-zero balance. Ported from the AIP fix
 * (bd6e393): non-change amounts must not be clamped near-zero.
 */
export const resolveChangeDisplay = (parseValue: number, precision: number, isChange: boolean, showSign: boolean) => {
  if (!isChange) return { isUp: null, finalValue: parseValue, sign: '' };
  const threshold = Math.pow(10, -precision);
  const nearZero = Math.abs(parseValue) <= threshold;
  const isUp = nearZero ? null : parseValue > 0;
  const finalValue = nearZero ? 0 : parseValue;
  const sign = showSign && isUp !== null ? (isUp ? '+' : '-') : '';
  return { isUp, finalValue, sign };
};
